module.exports = __webpack_public_path__ + "static/img/QRcodeTwo.2f12659b.png";